import React from "react";
import { connect } from "react-redux";
import { Redirect, Link } from "react-router-dom";
import {
  Transition,
  Container,
  Segment,
  Header,
  Button
} from "semantic-ui-react";
import { asignacionesOps } from "../ducks/asignaciones";
import { busquedasOps } from "../ducks/busquedas";
import AlumnosDisponibles from "./asignacionAlumnos/AlumnosDisponibles";
import AlumnosAsignados from "./asignacionAlumnos/AlumnosAsignados";
import InputData from "./shared/InputData";
import moment from "moment";

class AsignacionAlumnos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      redirectTo: null,
      showInputData: false,
      titulo: "",
      concepto: "",
      keyAlumno: "",
      visible: false
    };
  }

  componentDidMount() {
    this.props.fetchSearchDataAlumnos();
    this.props.obtenerAlumnosAsignados(this.props.asignacionData);
    this.setState(() => ({ visible: true }));
  }

  componentWillUnmount() {
    this.props.resetSearchDataAlumnos();
    this.props.resetAlumnosAsignados();
    this.props.detachAlumnosAsignados(this.props.asignacionData);
    this.setState(() => ({ visible: false }));
  }

  handleButtonClick = idAlumno => {
    if (idAlumno === "reset") return;

    let data = {
      idAlumno,
      idColegio: this.props.asignacionData.idColegio,
      idActividad: this.props.asignacionData.idActividad,
      fechaAlta: moment().format("YYYYMMDD"),
      fechaBaja: "-",
      baja: false,
      alta: true
    };

    this.props.altaAlumnoActividad(data);
    this.props.altaCobroActividad(data);
  };

  handleClickCerrar = () => {
    this.props.actionFetchDetalleColegio(this.props.asignacionData.idColegio);
    this.setState(() => ({
      redirect: true,
      redirectTo: <Redirect to="/detalle/colegio" />
    }));
  };

  handleRowClick = (keyAlumno, value, concepto, titulo) => {
    let valor = value;

    if (concepto === "fechaAlta" || concepto === "fechaBaja") {
      valor = moment(value, "YYYYMMDD").isValid()
        ? moment(value).format("DD/MM/YYYY")
        : "-";
    }

    this.setState({
      showInputData: !this.state.showInputData,
      concepto,
      titulo,
      value: valor,
      redirect: false,
      link: null,
      keyAlumno
    });
  };

  handleShowInput = () =>
    this.setState({
      showInputData: !this.state.showInputData,
      concepto: "",
      titulo: "",
      value: "",
      redirect: false,
      link: null
    });

  handleSaveModal = (concepto, value, idAlumno) => {
    let values = {};

    switch (concepto) {
      case "fechaAlta":
        values = {
          idColegio: this.props.asignacionData.idColegio,
          idActividad: this.props.asignacionData.idActividad,
          keyAlumno: this.state.keyAlumno,
          fechaAlta: moment(value, "DD/MM/YYYY").isValid()
            ? moment(value, "DD/MM/YYYY").format("YYYYMMDD")
            : moment().format("YYYYMMDD")
        };

        this.props.updateAlumnoActividad(values);
        break;

      case "fechaBaja":
        values = {
          idColegio: this.props.asignacionData.idColegio,
          idActividad: this.props.asignacionData.idActividad,
          keyAlumno: this.state.keyAlumno,
          fechaBaja: moment(value, "DD/MM/YYYY").isValid()
            ? moment(value, "DD/MM/YYYY").format("YYYYMMDD")
            : moment().format("YYYYMMDD"),
          baja: true
        };

        const baja = {
          ...this.props.asignacionData,
          ...this.props.alumnosAsignados.filter(
            alumno => alumno.key === this.state.keyAlumno
          )[0],
          ...values
        };

        this.props.tramitarBajaAlumno(baja);
        this.props.bajaCobroActividad(values);
        this.props.bajaAlumnoActividad(values);
        break;

      default:
        break;
    }

    this.setState({
      showInputData: !this.state.showInputData,
      concepto: "",
      titulo: "",
      value: "",
      redirect: false,
      link: null
    });
  };

  handleBorrarAlumno = info => {
    this.props.eliminarAlumnoActividad(
      Object.assign({}, info, this.props.asignacionData)
    );
  };

  handleVolver = () => this.props.history.goBack();

  render() {
    const {
      match: { params }
    } = this.props;

    if (this.state.redirect) {
      return this.state.redirectTo;
    }

    return (
      <Transition.Group animation="scale" duration={250}>
        {this.state.visible && (
          <Container>
            <Segment basic>
              <Button
                as={Link}
                to={`/detalle/colegio/${params.idColegio}`}
                content="Volver"
                color="pink"
                icon="cancel"
                floated="right"
              />
              <Header inverted as="h2" textAlign="center">
                Asignación de Alumnos
              </Header>
              <Header inverted as="h3" textAlign="center">
                Actividad: {this.props.asignacionData.actividad}
              </Header>
              <Header inverted as="h3" textAlign="center">
                Colegio: {this.props.asignacionData.nombreColegio}
              </Header>
            </Segment>
            <Segment>
              <AlumnosDisponibles
                handleButtonClick={this.handleButtonClick}
                datosBusqueda={this.props.searchDataAlumnos}
              />
              <AlumnosAsignados
                datos={this.props.alumnosAsignados}
                handleRowClick={this.handleRowClick}
                editable={true}
                handleBorrarAlumno={this.handleBorrarAlumno}
              />
            </Segment>
            {this.state.showInputData && (
              <InputData
                titulo={this.state.titulo}
                nombre={this.state.concepto}
                value={this.state.value}
                show={this.state.showInputData}
                closeDialog={this.handleShowInput}
                saveModal={this.handleSaveModal}
              />
            )}
          </Container>
        )}
      </Transition.Group>
    );
  }
}

const mapStateToProps = state => ({
  asignacionData: state.asignaciones.asignacionData,
  searchDataAlumnos: state.busquedas.searchDataAlumnos,
  alumnosAsignados: state.asignaciones.alumnosAsignados
});

const actions = {
  fetchSearchDataAlumnos: busquedasOps.fetchSearchDataAlumnos,
  resetSearchDataAlumnos: busquedasOps.resetSearchDataAlumnos,
  detachAlumnosAsignados: asignacionesOps.detachAlumnosAsignados,
  obtenerAlumnosAsignados: asignacionesOps.obtenerAlumnosAsignados,
  resetAlumnosAsignados: asignacionesOps.resetAlumnosAsignados,
  altaAlumnoActividad: asignacionesOps.altaAlumnoActividad,
  altaCobroActividad: asignacionesOps.altaCobroActividad,
  bajaCobroActividad: asignacionesOps.bajaCobroActividad,
  bajaAlumnoActividad: asignacionesOps.bajaAlumnoActividad,
  updateAlumnoActividad: asignacionesOps.updateAlumnoActividad,
  eliminarAlumnoActividad: asignacionesOps.eliminarAlumnoActividad,
  tramitarBajaAlumno: asignacionesOps.tramitarBajaAlumno
};

export default connect(mapStateToProps, actions)(AsignacionAlumnos);



// WEBPACK FOOTER //
// ./src/pages/AsignacionAlumnos.jsx